import * as types from '../../../../constants/ActionNameConstants';
import {
  ADD_SPEAKER_LABEL,
  GET_SLATE_DATA_FAILED,
  GET_SLATE_DATA_SUCCESS,
  UPDATE_SLATE_DATA,
  UPDATE_COMPLETED_PERCENTAGE,
} from '../../../../constants/ActionNameConstants';

export const getSlateDataRequest = (payload) => {
  return {
    type: types.GET_SLATE_DATA_REQUEST,
    payload,
  };
};

export const getSlateDataSuccess = (data) => ({
  type: GET_SLATE_DATA_SUCCESS,
  payload: data,
});

export const getSlateDataFailure = (err) => ({
  type: GET_SLATE_DATA_FAILED,
  payload: err,
});

export const addSpeakerLabel = (label) => ({
  type: ADD_SPEAKER_LABEL,
  payload: label,
});

export const updateSlateData = (data) => ({
  type: UPDATE_SLATE_DATA,
  payload: data,
});

export const updateFlagSlateData = (data) => ({
  type: types.UPDATE_FLAG_SLATE_DATA,
  payload: data,
});

export const updateCompletedPercentage = (data) => ({
  type: types.UPDATE_COMPLETED_PERCENTAGE,
  payload: data,
});

export const updateCompletedByIndex = (data) => ({
  type: types.UPDATE_COMPLETED_BY_INDEX,
  payload: data,
});

export const updateSlateDataLoadingState = (data) => ({
  type: types.UPDATE_SLATE_DATA_LOADING_STATE,
  payload: data,
});

export const updateSlateIsDirty = (data) => ({
  type: types.UPDATE_SLATE_IS_DIRTY,
  payload: data,
});

// New action creator to reset completion percentage
export const resetCompletedPercentage = () => ({
  type: types.RESET_COMPLETED_PERCENTAGE,
});

export const updateSlateVendorNotes = (data) => ({
  type: types.UPDATE_SLATE_VENDOR_NOTES,
  payload: data,
});

export const updateSlateSelectedNode = (data) => ({
  type: types.UPDATE_SLATE_SELECTED_NODE,
  payload: data,
});

export const updateSlateIsClaim = (data) => ({
  type: types.UPDATE_SLATE_IS_CLAIM,
  payload: data,
});

export const resetEditorState = () => ({
  type: types.RESET_EDITOR_STATE,
});

export const updateScrollToIndexValue = (data) => ({
  type: types.UPDATE_SCROLL_TO_INDEX_VALUE,
  payload: data,
});

export const getLegalTemplateFormFieldDetailsRequest = (payload) => ({
  type: types.GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST,
  payload,
});

export const getLegalTemplateFormFieldDetailsSuccess = (data) => ({
  type: types.GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_SUCCESS,
  payload: data,
});

export const getLegalTemplateFormFieldDetailsFailure = (err) => ({
  type: types.GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_FAILED,
  payload: err,
});
